/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_all_variants_sold_out = /** @type {(inputs: {}) => string} */ () => {
	return `Všechny varianty jsou vyprodány`
};

const da_all_variants_sold_out = /** @type {(inputs: {}) => string} */ () => {
	return `Alle varianter er udsolgt`
};

const de_all_variants_sold_out = /** @type {(inputs: {}) => string} */ () => {
	return `Alle Varianten ausverkauft`
};

const en_all_variants_sold_out = /** @type {(inputs: {}) => string} */ () => {
	return `All variants are sold out`
};

const es_all_variants_sold_out = /** @type {(inputs: {}) => string} */ () => {
	return `Todas las variantes están agotadas`
};

const fr_all_variants_sold_out = /** @type {(inputs: {}) => string} */ () => {
	return `Toutes les variations sont épuisées`
};

const hu_all_variants_sold_out = /** @type {(inputs: {}) => string} */ () => {
	return `Az összes variáció elfogyott`
};

const it_all_variants_sold_out = /** @type {(inputs: {}) => string} */ () => {
	return `Tutte le varianti sono esaurite`
};

const nl_all_variants_sold_out = /** @type {(inputs: {}) => string} */ () => {
	return `Alle varianten zijn uitverkocht`
};

const pl_all_variants_sold_out = /** @type {(inputs: {}) => string} */ () => {
	return `Wszystkie warianty wyprzedane`
};

const pt_all_variants_sold_out = /** @type {(inputs: {}) => string} */ () => {
	return `Todas as variações esgotadas`
};

const sv_all_variants_sold_out = /** @type {(inputs: {}) => string} */ () => {
	return `Alla varianter är slutsålda`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const all_variants_sold_out = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.all_variants_sold_out(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("all_variants_sold_out", locale)
	if (locale === "cs") return cs_all_variants_sold_out(inputs)
	if (locale === "da") return da_all_variants_sold_out(inputs)
	if (locale === "de") return de_all_variants_sold_out(inputs)
	if (locale === "en") return en_all_variants_sold_out(inputs)
	if (locale === "es") return es_all_variants_sold_out(inputs)
	if (locale === "fr") return fr_all_variants_sold_out(inputs)
	if (locale === "hu") return hu_all_variants_sold_out(inputs)
	if (locale === "it") return it_all_variants_sold_out(inputs)
	if (locale === "nl") return nl_all_variants_sold_out(inputs)
	if (locale === "pl") return pl_all_variants_sold_out(inputs)
	if (locale === "pt") return pt_all_variants_sold_out(inputs)
	return sv_all_variants_sold_out(inputs)
};